/*
 * @Descripttion:
 * @Author: etong
 * @Date: 2022-03-18 16:12:00
 * @LastEditors: liujiang liujiang@shjinjia.com.cn
 * @LastEditTime: 2023-06-06 16:08:08
 */
// 红人库
const map = {
  // 媒介推广
  starOnlineInfo: () => import('@/views/media/ProOfbasicInfo'),
  promotionPlan: () => import('@/views/media/ProAuditAndEffect'),
  brandPromotion: () => import('@/views/media/BrandPromotion'), // 品牌推广
  microblogGrab: () => import('@/views/media/MicroblogGrab'), // 微博数据抓取
  advReplacement: () => import('@/views/media/advReplacement'), // 广告置换
  advSystem: () => import('@/views/media/AdvSystem'), // 广告系统
  paymentReceive: () => import('@/views/media/PaymentReceive'), // 广告认领
  redManMonthKnot: () => import('@/views/media/RedManMonthKnot'), // 红人月结
  redManMonthDetail: () => import('@/views/media/RedManMonthDetail'), // 红人月结
  micoblogComment: () => import('@/views/media/MicoblogComment'), // 微博评论
  micoblogList: () => import('@/views/media/MicoblogList'), // 微博列表
  micoblogFansAnalysis: () => import('@/views/media/MicoblogFansAnalysis'), // 微博粉丝数分析
  bUpAnalysis: () => import('@/views/media/BUpAnalysis'), // B站UP主分析
  promotionSchemeList: () =>
      import('@/views/mediaPromotion/PromotionSchemeList'), // 推广方案
  promoteImplementation: () =>
      import('@/views/mediaPromotion/PromoteImplementation'), // 推广执行
  promotionSignContract: () =>
      import('@/views/mediaPromotion/PromotionSignContract'), // 签署合同
  promotionSettlement: () =>
      import('@/views/mediaPromotion/PromotionSettlement'), // 推广结算
  promotionDataStatistics: () =>
      import('@/views/mediaPromotion/PromotionDataStatistics'), // 数据统计
  newPromotionPlan: () => import('@/views/mediaPromotion/NewPromotionPlan'), // 新建推广方案
  promotionGoodsList: () => import('@/views/mediaPromotion/PromotionGoodsList'), // 推广商品
  promotionDetail: () => import('@/views/mediaPromotion/components/PromotionDetails'), // 一般推广详情
  livePromotionDetail: () => import('@/views/mediaPromotion/components/LivePromotionDetails'), // 直播推广详情
  celebrityCooperationList: () => import('@/views/mediaPromotion/PromotionSchemeList/CelebrityCooperationList'), // 红人合作信息
  applyCreditDetail: () => import('@/views/media/ApplyCreditDetail'), // 广告申请授信详情
  // 红人库
  internetCelebrityLibrary: () =>
      import('@/views/internetCelebrityRoom/InternetCelebrityLibrary'), // 红人库
  internetCelebrityDetail: () =>
      import('@/views/internetCelebrityRoom/InternetCelebrityDetail'), // 红人详情
  internetCelebrityBlackList: () =>
      import('@/views/internetCelebrityRoom/InternetCelebrityBlackList'), // 红人黑名单
  internetCelebrityBD: () =>
      import('@/views/internetCelebrityRoom/InternetCelebrityBD'), // 红人BD
  internetCelebrityBDDetail: () =>
      import('@/views/internetCelebrityRoom/InternetCelebrityBD/InternetCelebrityBDDetail'), // 红人BD详情
  internetCelebrityLabel: () =>
      import('@/views/internetCelebrityRoom/InternetCelebrityLabel'), // 红人标签
  internetCelebrityPlatform: () =>
      import('@/views/internetCelebrityRoom/InternetCelebrityPlatform'), // 红人平台
  internetCelebrityPlatformDetail: () =>
      import('@/views/internetCelebrityRoom/InternetCelebrityPlatform/InternetCelebrityPlatformDetail'), // 红人平台
  inernetCelebrityInsider: () =>
      import('@/views/internetCelebrityRoom/inernetCelebrityInsider'), // 内部红人
  videoAuthorizationSettlementList: () => import('@/views/media/VideoAuthorizationSettlementList'), // 视频授权结算列表

  // 创建视频授权申请单
  promoteVidoAuthorizeApplyModule: () => import('@/views/media/PromoteVidoAuthorizeApply/index'),
  promoteVidoAuthorizeApplyModuleDetail: () => import('@/views/media/PromoteVidoAuthorizeApply/Detail')

}

export default map
